import dayjs from 'dayjs';
import { useEffect } from 'react';

import { getOrderShortCode, getReadyTime } from '../lib/orderMeta';
import styles from './Orders.module.scss';

import { orderStore } from '@/entities/order/store/orderStore';
import { OrderSuccessButton } from '@/features/orders/ui/OrderSuccessButton/OrderSuccessButton';
import { observer } from '@/shared/lib/signal/observer';

export const OrdersWidget = observer(() => {
  const getOrders = () => {
    const access = localStorage.getItem('accessToken');
    if (access) orderStore.fetchUserOrders();
  };

  useEffect(() => {
    getOrders();
  }, []);

  const orders = orderStore.visibleOrders.value;

  useEffect(() => {
    if (!orderStore.lastVisibleOrder.value) {
      return () => {};
    }

    let intervalId: ReturnType<typeof setInterval> | null = null;
    const now = dayjs();
    const lastDate = dayjs(orderStore.lastVisibleOrder.value.createdAt);

    if (now.diff(lastDate, 'seconds') > 5 * 60) {
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
      return () => {};
    }

    intervalId = setInterval(() => {
      getOrders();
    }, 15 * 1000);

    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderStore.lastVisibleOrder.value]);

  if (!orders.length) return null;

  return (
    <>
      <div className={styles.container}>
        {orders.map((order) => {
          const orderId = getOrderShortCode(order);
          const readyTime = getReadyTime(order.createdAt, 5, 'ru-RU');

          return (
            <OrderSuccessButton
              key={order.id}
              orderId={orderId}
              readyTime={readyTime}
              status={order.status}
              onClick={() => orderStore.openOrderStatusModal(order.id)}
            />
          );
        })}
      </div>
    </>
  );
});
